console.log('scripts.js v2');

function nominetSearchFlyoutTrigger(){

    const trigger = document.querySelector('.nominet-search-flyout__trigger');
    const target = document.querySelector('.nominet-search-flyout');
    const active = 'js-active'

    if(!trigger || !target) return

    trigger.addEventListener('click', () => { 

        if(target.classList.contains(active)) {
            target.classList.remove(active);
            trigger.classList.remove(active);
            trigger.querySelector('a').innerText = "Search";
        } else {
            target.classList.add(active);
            trigger.classList.add(active);
            trigger.querySelector('a').innerText = "Close";
        }
    });
}

function setNoDuotoneCSSClassForGraphics(){

    const allFeaturedPostImages = document.querySelectorAll(".wp-block-post-featured-image img")
    
    if(!allFeaturedPostImages) return

    for(let postImage of allFeaturedPostImages){

        if(postImage.currentSrc.includes('untreated')){ // <-- filename should have the word "untreated" in it somewhere.

            postImage.parentElement.classList.add('js-no-duotone');
        }
    }
}

function backToTopButton(){

    const triggerLine = document.querySelector("#back-to-top-trigger");
    const scrollToTopBtn = document.querySelector(".back-to-top-button");

    //More robust than setting html{scroll-behaviour:smooth} in CSS as this can be problematic if more CSS is ever introduced.
    scrollToTopBtn.addEventListener('click', (e) => {

        window.scrollTo({
            top: 0,
            behavior: "smooth",
          })
    })

    const callback = ([entry]) => {
        scrollToTopBtn.classList.toggle("back-to-top-button--visible", !entry.isIntersecting)  //<-- classList can toggle as well
    };

    //Use IntersectionObserver to evaluate if the triggerLine is visible or not and then show the button.
    const observer = new IntersectionObserver(callback);
    observer.observe(triggerLine);

}

function newsAlertBanner(){

    //Sets a cookie when the 'close' button is clicked. 
    //PHP template queries this to show again on load.

    const nominetNewsAlertBanner = document.querySelector('.nominet-news-alert-banner');
    const newsDismissButton =  document.querySelector('.js-dismiss-news');
    const newsCloseButton =  document.querySelector('.js-close-news');


    if(!newsDismissButton) return; //<-- early return as may already be hidden

    newsCloseButton.addEventListener('click', (event)=>{

        nominetNewsAlertBanner.style.display = 'none';
    })

    newsDismissButton.addEventListener('click', (event)=>{

        const setCookieValue = event.target.dataset.setCookieValue

        document.cookie = `nominet-news-alert-banner=${setCookieValue};max-age=31536000`; //<--one year expiry
        nominetNewsAlertBanner.style.display = 'none';
    })
}

function responsiveVideoIframe(){

    const videoIframes = document.querySelectorAll('iframe[title="vimeo-player"], .mobile-video-responsive iframe');

    for(let videoIframe of videoIframes){

        videoIframe.parentElement.classList.add('video-wrapper');

    }
}

//Mobile menu

function isResponsiveDevice() {
    
    // media query event handler
    if(matchMedia) {
        const mediaQuery = window.matchMedia('(max-width: 600px)')

        //initialise on page load
        WidthChange(mediaQuery);
        
        //check on change
        mediaQuery.addEventListener("change", () => {

            WidthChange(mediaQuery);
        })
    }

    // media query change
    function WidthChange(mediaQuery) {
        if (mediaQuery.matches) {
            // window width is at least 500px
            mobileNavMenu()
        } 
    }
}

function mobileNavMenu() {
    
    const mobileNavMenuElement = document.querySelector('.wp-block-navigation__responsive-container');
    const subMenus = document.querySelectorAll(".wp-block-navigation__submenu-container");
    
    for(const subMenu of subMenus ){
        
        const clickToggleElement = subMenu.parentElement.querySelector('a.wp-block-navigation-item__content')
        subMenu.classList.add('js-closed')
        clickToggleElement.classList.add('js-menu-element-closed')

        //Create some top level links
        const href = clickToggleElement.href
        const text = clickToggleElement.textContent
        const aTag = document.createElement('a');
        if (href) {
            
            aTag.classList.add('js-dropdown-link')
            aTag.textContent = `Go to ${text} page`
            aTag.href = href           
        }
    
        clickToggleElement.addEventListener('click', (event) => {

            event.preventDefault(); //turns link into dropdown
            subMenu.classList.toggle('js-closed');
            subMenu.classList.toggle('js-open');
            clickToggleElement.classList.toggle('js-menu-element-closed')
            clickToggleElement.classList.toggle('js-menu-element-open')
            
            subMenu.prepend(aTag)
        } )

    }


}

//Init functions
document.addEventListener('DOMContentLoaded', () => {

    nominetSearchFlyoutTrigger()
    setNoDuotoneCSSClassForGraphics()
    backToTopButton()
    responsiveVideoIframe()
    isResponsiveDevice()

})

// trigger an event when the mobile hamburger button is clicked
jQuery( 'body .nominet-header button.wp-block-navigation__responsive-container-open' ).on('click', function(e) {

    // check that the menu is actually open
    if( jQuery('html').hasClass('has-modal-open') && jQuery(this).siblings('.wp-block-navigation__responsive-container').hasClass('has-modal-open') && jQuery(this).siblings('.wp-block-navigation__responsive-container').hasClass('is-menu-open') ) {
        e.preventDefault();
        //prevent page scroll while menu open

        // click the hidden close button
        jQuery(this).siblings('.wp-block-navigation__responsive-container').find('.wp-block-navigation__responsive-container-close').click();

        var element = jQuery(this).siblings('.wp-block-navigation__responsive-container').find('.wp-block-navigation__responsive-container-close');
        
        setTimeout(function() {
            element.click();
        }, 250);

    }

    if (jQuery('body').hasClass('no-scroll')) {
        document.body.classList.remove('no-scroll');
    } else {
        document.body.classList.add('no-scroll');
    }

});

// Close menu on Escape key press
document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
        if ( jQuery('body').hasClass('no-scroll') ) {
            document.body.classList.remove('no-scroll');
        }
    }
});

///Existing Tracking from 2017 template
/**
* Google Analytics event tracking
*/
jQuery( document ).ready(function($) {
 var html = $("html") 
 var query = $('#query') || $('#domain'); //two search forms 
     html.on('click', '.registrar', function() {
        setTimeout( function() {
            ga('send', 'event', {
                eventCategory: 'External Link',
                eventAction: 'click',
                eventLabel: $('.registrar').attr('href'),
                transport: 'beacon'
            });
            console.log('event sent .external', $('.registrar').attr('href'));  
        }, 500);
    });
    html.on('click', '.pick-domain', function() {
        $(this).attr('data-href', query.val());
        setTimeout( function() {
            ga('send', 'event', {
                eventCategory: 'Homepage',
                eventAction: 'Domain search',
                eventLabel: $('.pick-domain').data('href'),
                transport: 'beacon'
            });
            console.log('event sent .pick-domain', $('.pick-domain').data('href'));   
        }, 500);
    });
})
